import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../interface';
import { getPLPOExperienceThunk } from '../thunks/plpo-experience.thunk';
export const plpoExperienceSliceName = 'plpoExperience';
export const initialPLPODataState = {
  groupKey: '',
  isEligible: false,
  progress: 0,
  hasError: false,
  status: RequestStatus.IDLE,
  lastInitiated: undefined
};
export const {
  reducer: plpoExperienceReducer,
  actions: plpoExperienceActions
} = createSlice({
  name: plpoExperienceSliceName,
  initialState: initialPLPODataState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPLPOExperienceThunk.pending, state => {
      state.status = RequestStatus.LOADING;
    });
    builder.addCase(getPLPOExperienceThunk.fulfilled, (state, action) => {
      state.status = RequestStatus.SUCCESS;
      state.hasError = false;
      state.groupKey = action.payload.groupKey;
      state.isEligible = action.payload.isEligible;
      state.progress = action.payload.progress;
      state.status = RequestStatus.SUCCESS;
      state.lastInitiated = Date.now();
    });
    builder.addCase(getPLPOExperienceThunk.rejected, state => {
      state.status = RequestStatus.ERROR;
      state.hasError = true;
    });
  }
});